import {Component, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class HeaderComponent implements OnInit {
   // show: boolean = false;
    collapse: string = 'closed';

    constructor(
        private titleService: Title
    ) {
    }

    @HostListener('window:scroll')
    checkScroll() {

       /* if (scrollPosition === 0) {
            document.getElementById('navbar1').classList.add('scroll-default');
            document.getElementById('navbar1').classList.remove('scroll-top');
            document.getElementById('navbar1').classList.remove('scroll-down');

        }*/
    }

    ngOnInit() {



    }
/*
    toggleCollapse(event) {
        this.show = !this.show;
        console.log(this.show, event);

    }*/
/*
    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }*/
}
